import { render } from "./WclsInfo.vue?vue&type=template&id=2a618c42&scoped=true"
import script from "./WclsInfo.vue?vue&type=script&lang=js"
export * from "./WclsInfo.vue?vue&type=script&lang=js"

import "./WclsInfo.vue?vue&type=style&index=0&id=2a618c42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a618c42"]])

export default __exports__